/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  UpdateViewMutationRequest,
  UpdateViewMutationResponse,
  UpdateViewPathParams,
} from "../types/UpdateView.ts"

export const updateViewMutationKey = () =>
  [{ url: "/v1/view/update-view/:id" }] as const

export type UpdateViewMutationKey = ReturnType<typeof updateViewMutationKey>

/**
 * @summary Update a view
 * {@link /v1/view/update-view/:id}
 */
export async function updateView(
  id: UpdateViewPathParams["id"],
  data: UpdateViewMutationRequest,
  config: Partial<RequestConfig<UpdateViewMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateViewMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateViewMutationRequest
  >({
    method: "PUT",
    url: `/v1/view/update-view/${id}`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateViewMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<UpdateViewMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = updateViewMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateViewMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: UpdateViewPathParams["id"]; data: UpdateViewMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return updateView(id, data, config)
    },
  })
}

/**
 * @summary Update a view
 * {@link /v1/view/update-view/:id}
 */
export function useUpdateView<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateViewMutationResponse>,
      ResponseErrorConfig<Error>,
      { id: UpdateViewPathParams["id"]; data: UpdateViewMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<UpdateViewMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateViewMutationKey()

  const baseOptions = updateViewMutationOptions(config) as UseMutationOptions<
    ResponseConfig<UpdateViewMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: UpdateViewPathParams["id"]; data: UpdateViewMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateViewMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: UpdateViewPathParams["id"]; data: UpdateViewMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateViewMutationResponse>,
    ResponseErrorConfig<Error>,
    { id: UpdateViewPathParams["id"]; data: UpdateViewMutationRequest },
    TContext
  >
}
